import { useCallback, useMemo } from "react"

import { useSearch, useLocation } from "wouter"

import { CATEGORY_SEARCH_PARAM_NAME } from "@/config"

import { parseCategoryParam } from "../../schemas/urlParamSchemas"

const useCategoryParam = () => {
  const search = useSearch()
  const [location, navigate] = useLocation()

  const categoryId = useMemo(() => {
    const params = new URLSearchParams(search)
    const rawCategory = params.get(CATEGORY_SEARCH_PARAM_NAME)
    return parseCategoryParam(rawCategory)
  }, [search])

  const setCategory = useCallback(
    (id: number) => {
      const params = new URLSearchParams(search)
      params.set(CATEGORY_SEARCH_PARAM_NAME, String(id))
      navigate(`${location}?${params.toString()}`, { replace: false })
    },
    [search, location, navigate]
  )

  const clearCategory = useCallback(() => {
    const params = new URLSearchParams(search)
    params.delete(CATEGORY_SEARCH_PARAM_NAME)
    const query = params.toString()
    navigate(query ? `${location}?${query}` : location, { replace: false })
  }, [search, location, navigate])

  return { categoryId, setCategory, clearCategory }
}

export default useCategoryParam
